export default "__VITE_ASSET__DmUO9LAI__"